import { Outlet } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";

import AppAppBar from "../Components/AppAppBar";
import Footer from "../Components/Footer";
import { useAuth } from "../hooks/useAuth";

import Banner from "../Components/Banner";
import "../App.css";

function RootLayout() {
  const { authed, profile, loading } = useAuth();

  const [showBanner, setShowBanner] = useState(false);

  const handleDismissBanner = () => {
    const expiresAt = Date.now() + 2 * 24 * 60 * 60 * 1000;
    localStorage.setItem("profileBannerDismissed", expiresAt);
    setShowBanner(false);
  };

  const profileIsIncomplete = useCallback(() => {
    return (
      authed &&
      (!profile?.favorite_food ||
        !profile?.age_range ||
        !profile?.spice_level ||
        !profile?.gender ||
        !profile?.ask_me_about ||
        !profile?.cuisines?.length)
    );
  }, [authed, profile]);

  useEffect(() => {
    if (loading) return;
    if (!authed || !profile) return;

    const dismissed = localStorage.getItem("profileBannerDismissed");
    const isDismissed = dismissed && Date.now() < parseInt(dismissed);

    if (!isDismissed && profileIsIncomplete()) {
      setShowBanner(true);
    } else {
      setShowBanner(false);
    }
  }, [loading, authed, profile, profileIsIncomplete]);

  return (
    <>
      <AppAppBar />
      {showBanner && (
        <>
          <div className="banner-fade">
            <Banner
              position="top"
              backgroundColor="var(--color-yellow)"
              title="Your profile isn't quite ready yet."
              message="Add your favourite dish, cuisines and spice level to join events."
              linkText="Complete Profile →"
              linkTo="/dashboard/profile/edit"
              onDismiss={handleDismissBanner}
            />
          </div>
          <div className="banner-spacer" />
        </>
      )}
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

export default RootLayout;
